import React from "react";
import Layout from "../../../../Components/Common/Layout";
import DashLayout from "../../../../Components/Admin/AdminDashLayout";
import MainSection from "./MainSection";
import { useSelector } from "react-redux";
import useNavHeading from "../../../../Hooks/CommonHooks/useNavHeading ";
import { useTranslation } from "react-i18next";

const TakeStaffAttendance = () => {
 
  const { t } = useTranslation("admClass");
  useNavHeading(t("Staff Attendance"), t("Take Attendance"));
  return (
    <Layout title={t(`Take Attendance | Office Flow`)}>
      
      <DashLayout children={<MainSection />} hideStudentView={true} />
      
    </Layout>
  );
};

export default TakeStaffAttendance;
